module.exports = __webpack_public_path__ + "img/icon76.99dc2fd7.png";